module.exports = __webpack_public_path__ + "static/SearchVideoPR-93e101fdbc2ddc25bfaac2a6a2e64e9e.mp4";